<div [formGroup]="form" class="py-2">
  <div class="flex flex-col justify-between gap-4 p-6 w-12/12">
    <div class="flex justify-between items-center">
      <h2 class="text-lg font-semibold">Editar Documento</h2>

      <mat-icon class="btn-icon-outline" fontIcon="close" (click)="close()" />
    </div>
    <div class="flex justify-between items-center w-12/12 gap-2">
      <div class="flex justify-start items-center gap-2 w-8/12">
        <mat-form-field
          class="input-tg mt-message-input w-4/12"
          appearance="outline"
        >
          <mat-label>Descrição</mat-label>
          <input matInput formControlName="description" />
        </mat-form-field>
        <div class="mt-message-input w-8/12">
          <input
            hidden
            type="file"
            (change)="onFileSelected($event)"
            #fileInput
          />
          <mat-form-field
            class="input-tg input-btn-icon w-full"
            appearance="outline"
          >
            <mat-label>Arquivo</mat-label>
            <input matInput formControlName="file" readonly />
            <button mat-icon-button matSuffix (click)="fileInput.click()">
              <mat-icon>upload</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <div class="flex items-center justify-end ml-2 gap-3 w-4/12">
        <button mat-flat-button class="btn-tg w-4/12" (click)="cancel()">
          Voltar
        </button>

        <button
          mat-flat-button
          class="btn-tg w-4/12"
          [disabled]="!hasChanges() || form.invalid || loading"
          (click)="editFile()"
        >
          @if (loading) {
            <mat-spinner
              diameter="22"
              class="loading-spinner"
              selected-track-color="red"
            ></mat-spinner>
          } @else {
            Editar
          }
        </button>
      </div>
    </div>
  </div>
</div>
